import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Trophy, Users, CalendarClock, Menu } from 'lucide-react';
import { hapticImpact } from '../native';

/**
 * Native-only bottom tab bar. This is the primary navigation surface when
 * running as an iOS/Android app -- it deliberately does not mirror the
 * website's top nav, so the app reads as an app, not a wrapped page.
 */
export const NativeTabBar = ({ onMenuPress }) => {
  const location = useLocation();

  const tabs = [
    { path: '/', label: 'Home', icon: Home, exact: true },
    { path: '/tournaments', label: 'Tournaments', icon: Trophy },
    { path: '/teams', label: 'Teams', icon: Users },
    { path: '/games', label: 'Games', icon: CalendarClock },
  ];

  const isActive = (tab) =>
    tab.exact ? location.pathname === tab.path : location.pathname.startsWith(tab.path);

  return (
    <nav
      className="native-tab-bar fixed inset-x-0 bottom-0 z-50 flex items-stretch border-t bg-background/95 backdrop-blur"
      data-testid="native-tab-bar"
    >
      {tabs.map((tab) => {
        const active = isActive(tab);
        return (
          <Link
            key={tab.path}
            to={tab.path}
            onClick={() => hapticImpact('light')}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-1.5 text-[11px] font-medium ${
              active ? 'text-primary' : 'text-muted-foreground'
            }`}
            data-testid={`native-tab-${tab.label.toLowerCase()}`}
          >
            <tab.icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
            {tab.label}
          </Link>
        );
      })}
      <button
        type="button"
        onClick={() => {
          hapticImpact('light');
          onMenuPress();
        }}
        className="flex-1 flex flex-col items-center justify-center gap-1 py-1.5 text-[11px] font-medium text-muted-foreground"
        data-testid="native-tab-menu"
      >
        <Menu className="w-5 h-5" />
        Menu
      </button>
    </nav>
  );
};
